import { render, staticRenderFns } from "./SepaBankTransfer.vue?vue&type=template&id=ce2daa1e"
import script from "./SepaBankTransfer.vue?vue&type=script&lang=js"
export * from "./SepaBankTransfer.vue?vue&type=script&lang=js"
import style0 from "./SepaBankTransfer.vue?vue&type=style&index=0&id=ce2daa1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports